
import React, {useRef, useState,useEffect} from 'react';
import HoverPortal from '../hoverPortal';
import PortalModal from '../portal_modal';
import PortalActions from '../portal_actions';
import useActions from '../../hooks/useActions';
import { deleteProjectTypes, restoreProjectStateTypes } from '../../state/action';
import './project.scss'

function createMarkup(thumbnail) { return {__html: thumbnail}; };

const setThumbnailSize = (svgElement, thumbnailWrapperDimensions) => {

  if(svgElement['viewBox']!== undefined && thumbnailWrapperDimensions) {
      var svgWidth = svgElement['viewBox']['animVal']['width'];
      var svgHeight = svgElement['viewBox']['animVal']['height'];
      var aspectRatio = svgWidth/svgHeight;
      var divWidth = thumbnailWrapperDimensions['width'];
      var divHeight = thumbnailWrapperDimensions['height'];
      svgWidth = divWidth;
      svgHeight = divWidth / aspectRatio;
      //If SVG image height is more then svg height is set to Div height and corresponding asepect ration is measured.
      if(svgHeight > divHeight) {
          svgHeight = divHeight;
          svgWidth = divHeight * aspectRatio;
      }
      return {'width': svgWidth+'px', 'height': svgHeight+'px'};
  }
}

interface Dimensions {
  width: number;
  height:number;
}

export interface ProjectParams {
  id: string;
  dimensions: Dimensions;  
  showDeleteIcon: boolean;
  projectType: string;
  thumbnailUrl: string;
  state: restoreProjectStateTypes | deleteProjectTypes | "Bound" | "Modified";
  sourceGroup: string;
  saveSourceGroup: string;
  editProjectUrl: string;
  year: string;
  group: string;
  projectName: string;
  projectDate: string;
  currentState: string;
  deletionDate: string;
  orderId: string;
}

//@ts-ignore
const translations = photoOrg.translations;
//@ts-ignore
const utils = photoOrg.Util;
//@ts-ignore
const browserUtil = photoOrg.browserUtil;

export const Project: React.FC<ProjectParams> = (props)=>{
  const {open, close, openModal, closeModal} = PortalActions()
  const [added, setAdded] = useState(false);
  const ele = useRef("");
  const headerTxt = useRef("")
  const bodyTxt = useRef("")
  const actionTxt = useRef("")
  const omnitureTxt = useRef("")
  const trackingTxt = useRef(null)
  const actionCallback = useRef(null);

  const { removeProjectFromCart, restoreProject, delProject } = useActions();

  //@ts-ignore
  const msg = (props.state!=="Archived")? translations.projects["projects"]["edit_project_edit"]:translations.projects["projects"]["purchased"]["copy"]
  const svgThumbnailWrapperRef   = useRef(null);
  let [dimensions,setDimension] = useState({});

  useEffect ( () => {
    if(svgThumbnailWrapperRef.current){
        let thumbnailWrapperDimensions = {"width": svgThumbnailWrapperRef.current.offsetWidth, "height": svgThumbnailWrapperRef.current.offsetHeight}
        if (props.thumbnailUrl && props.thumbnailUrl.indexOf('<svg') !== -1)  //setting the thumbnail sizes only for svg's
        setDimension(setThumbnailSize(svgThumbnailWrapperRef.current.firstChild,thumbnailWrapperDimensions));    
    }
}, [svgThumbnailWrapperRef]);

  const handleHover = (shouldAdd, element) => {
    if(props.state.indexOf("Deleted") !== -1 || (browserUtil.isTouchDevice() && !browserUtil.isDesktop())) {
      return
    }
    setAdded(shouldAdd);
    if(shouldAdd){
        ele.current = element.getElementsByClassName("thumbnail-area")[0];
        element.classList.add('projectHover')
    }else{
        ele.current = "";
        element.classList.remove('projectHover')
    }
  }
  const onBlurAction = (ele, triggerBlurAction) =>{
    triggerBlurAction && handleHover(false, ele.currentTarget.closest(".pruduct_img_div"));
  }
  const openRestoreOverlay = () => {
      const projectState = (props.state === "DeletedArchived") ? "Purchased": (props.state === "DeletedFree") ? "Saved": "";
      utils.trackLinksAndButtons('Restore '+projectState +' Project','projectsPage');
      headerTxt.current = translations.projects["restore_project_alert"]
      bodyTxt.current = (props.state!=="DeletedArchived") ? translations.projects["action_container"]["restore_saved"]:
                        translations.projects["action_container"]["restore_purchased"]
      actionTxt.current = translations.projects["action_container"]["restore"]
      omnitureTxt.current = "restore-button"
      actionCallback.current = restore;
      trackingTxt.current = null;
      openModal()
  }
  const restore = () => {
      closeModal();
      restoreProject(props.id, props.state as any);
  }
  const deleteProject = () => {
    {/** @ts-ignore */}
    utils.trackLinksAndButtons('Delete '+props.state.charAt(0).toUpperCase() + props.state.slice(1)+' Project','projectsPage');
    headerTxt.current = translations.projects["delete_project_warning"]
    omnitureTxt.current = "delete-button"
    {/** @ts-ignore */}
    bodyTxt.current = (photoOrg.config.enablePermanentDelete && props.state !== 'Archived') ? translations.projects["action_container"]["delete_project_confirm"]
                       : translations.projects["projects"]["delete_this_project"]
    actionTxt.current = translations.projects["action_container"]["Delete"]
    actionCallback.current = del;
    trackingTxt.current = null;
    openModal()
  }
  const del = () => {
    closeModal();
    delProject(props.state as any, props.id)
  }
  const editProject = () => {
    if(props.state == 'DeletedFree' || props.state == 'DeletedArchived') return
    let portableProjectConfig = getPortableProjectConfig();
    if(props.state === "Free"){
        redirectToProject();
        return;
    }else if(portableProjectConfig.isProjectInAppCart){
        omnitureTxt.current = "edit-button"
        if(portableProjectConfig.isProjectInIOSCart){
            utils.trackLinksAndButtons('AppProjectInCartiOS','projectsPage');
            headerTxt.current = translations.projects["projects"]["edit_project_confirmation_header"];  
            bodyTxt.current = translations.projects["projects"]["port_ios_confirmation_body1"];
            actionTxt.current = translations.projects["projects"]["port_confirmation_okay"];
            actionCallback.current = redirectToProject;
            trackingTxt.current = 'ProjectAppCartOKButton';
        }else{
            utils.trackLinksAndButtons('AppProjectInCartAndroid','projectsPage');
            headerTxt.current = translations.projects["projects"]["edit_project_confirmation_header"];
            bodyTxt.current = translations.projects["projects"]["port_confirmation_body"];
            actionTxt.current = translations.projects["projects"]["port_confirmation_okay"];
            actionCallback.current = removeProject;
            trackingTxt.current = 'RemoveAppProjectCartCancel';
        }

    }else{
        headerTxt.current = (props.state!=="Archived")? translations.projects["projects"]["edit_project_confirmation_header"] :
                            translations.projects["projects"]["purchased"]["head"]
        bodyTxt.current = (props.state!=="Archived") ? translations.projects["projects"]["edit_project_confirmation1"]:
                            translations.projects["projects"]["purchased"]["confirm_body"]
        actionTxt.current = (props.state!=="Archived")? translations.projects["projects"]["edit_project_edit"]:
                            translations.projects["projects"]["purchased"]["copy"]
        omnitureTxt.current = (props.state!=="Archived")? "edit-button": "reorder-button";
        actionCallback.current = redirectToProject;
        trackingTxt.current = 'RemoveAppProjectCartCancel';
    }
    openModal()
  }

  const removeProject = () => {
      closeModal();
      removeProjectFromCart(props);
      //@ts-ignore
      utils.trackLinksAndButtons('RemoveAppProjectCart','projectsPage');
  }
  const getPortableProjectConfig = () => {
      let isProjectInAppCart,isProjectInIOSCart = false;
      let saveSourceGroup = props.saveSourceGroup;
      let sourceGroup = props.sourceGroup;
      // For the projects that don't have saveSourceGroup attribute, we're referencing the sourceGroup attribute
      //@ts-ignore
      isProjectInAppCart = photoOrg.config.projects_portability
                          && (props.state === "Bound" || props.state === "Modified") &&
          ((saveSourceGroup && saveSourceGroup.length > 0) ? (saveSourceGroup[saveSourceGroup.length-1].indexOf("sf-store") === -1 ? true : false) : (sourceGroup.indexOf("sf-store") === -1 ? true : false));
      //Currently IOS app is not supporting portable projects removal, so showing a different message for IOS APP projects and disabling edit option.
      isProjectInIOSCart = isProjectInAppCart &&
          ((saveSourceGroup && saveSourceGroup.length > 0) ? (saveSourceGroup[saveSourceGroup.length-1].indexOf("sf-mobile-ios") !== -1 ? true : false) : (sourceGroup.indexOf("sf-mobile-ios") !== -1 ? true : false));

      return  {isProjectInAppCart,isProjectInIOSCart}
  }
  const isValidEditProjectUrl = (urlStr) => {
    try {
      const url = new URL(urlStr);
      const path = url.pathname.toLowerCase();
      return ((url.origin === window.location.origin) && (path && path.indexOf('/create/builder') > -1));
    } catch (e) {
      return false; // Invalid URL
    }
  };

  const redirectToProject = () => {
      //@ts-ignore
      utils.trackLinksAndButtons('Edit Projects','projectsPage');
      //Removing the selected albums array from local storage when edit is clicked as we do not want to show different set of images selected.
      //@ts-ignore
      photoOrg.storage.removeItemFromStorage(photoOrg.constants.storagekeys.SELECTED_ALBUMS,{addAccountId: true});
      let baseUrl = props.editProjectUrl;
      try {
        new URL(baseUrl);
      } catch {
        baseUrl = `https://${window.location.hostname}${baseUrl}`;
      }
      
      if (isValidEditProjectUrl(baseUrl)) {
        const separator = baseUrl.includes('?') ? '&' : '?';
        const fullUrl = `${baseUrl}${separator}projectId=${encodeURIComponent(props.id)}`;
        window.location.href = fullUrl;
      } else {
        //@ts-ignore
        photoOrg.clientLogger.error({description: "NEW PROJECTS:Invalid edit project URL:", errorCode: "LIBRARY:MYPROJECTS", baseUrl: baseUrl, quickLogger: true});

      }
  }

    //@ts-ignore
    return (<li className={`project_${props.id}`} gird_class={`grid_${props.year}`} data-id={`${props.id}`}>
    <div className="row">
    {open ? (
                    <PortalModal overlayContent={{header:(headerTxt.current),body:(bodyTxt.current), omnitureTxt: omnitureTxt.current, actionTxt: (actionTxt.current), trackingTxt: (trackingTxt.current)}}
                    isOpen={open}
                    onClose={closeModal}
                    onAction={actionCallback.current}
                    lastActiveEle = {
                      //@ts-ignore
                      $("#pruduct_img_div_"+props.id)
                    }
                     />) : null
    }
      <div className="small-12 pruduct_img_div" id={`pruduct_img_div_${props.id}`} onMouseOver = {(event) => handleHover(true,event.currentTarget)} onFocus = {(event) => handleHover(true,event.currentTarget)}
      onMouseLeave = {(event) => handleHover(false, event.currentTarget)} onKeyDown={(e)=>{onBlurAction(e, (e.shiftKey && e.key==="Tab"))}}
      tabIndex={0} aria-label={ translations.projects["Project"] + utils.getAltMessageFormat(props.projectName)}>
        <figure>
          {/** @ts-ignore */}
          <a onClick={editProject} tabIndex={-1} aria-label={`${utils.getAltMessageFormat(props.projectName)}`}  data-id={`${props.id}`} className={`highlightable ${!(props.state == 'DeletedFree'|| props.state == 'DeletedArchived')? "edit_project_url" : "no_hover"}`} id={`project_${props.id}`} edit_url={`${props.editProjectUrl}`} projectstate={`${props.state}`} projectgroup={`${props.group}`} ></a>
          <div className="thumbnail-area">
            <div className="add-hoverportal">

            {
              /** @ts-ignore */
              added ? <HoverPortal text= {msg} shouldAdd={added} el={ele.current.firstChild} project={props} blurAction={onBlurAction} deleteProject={deleteProject} editProject={editProject}></HoverPortal> : null
            }
            </div>

            {

          (props.thumbnailUrl && props.thumbnailUrl.indexOf("svg") === -1) ?
          <div className="thumbnail-wrapper"  style={{"width": props.dimensions['width'], "height": props.dimensions['height']}}>
          <img src={`${props.thumbnailUrl.indexOf("?")>-1 ? props.thumbnailUrl+"&" : props.thumbnailUrl+"?"}height=300&format=png`} className="project-img" alt="" />
          </div> :
          <div className="thumbnail-wrapper" ref={svgThumbnailWrapperRef} style={dimensions}  dangerouslySetInnerHTML = {createMarkup(props.thumbnailUrl)}>

          </div>


            }

            {(props.state == 'DeletedFree' || props.state == 'DeletedArchived')?
            <div className="delete_project_options">
                {/** @ts-ignore */}
                <a tabIndex={0} onKeyDown={(e)=>{if(e.key === " " || e.key === "Enter")openRestoreOverlay();}} onClick={openRestoreOverlay} className="restoreProject" project_id={`${props.id}`}>{ translations.projects["action_container"]["restore"]}</a>
                <span>{ translations.projects["projects"]["deleted"]["deleted_mobile"]}</span>
            </div>
            : ""}
          </div>
          <div className="project-caption-area">
            <div className="caption-wrapper">
              <h3>{props.projectName}</h3>
              <p>
                  {(props.state == 'DeletedFree' || props.state == 'DeletedArchived')?
                      <>
                      {/** @ts-ignore */}
                      <span className="delete-message">{translations.projects["projects"]["deleted"]["caption_date_lable"].replace("{date}",moment(props.deletionDate).format(photoOrg.config.date_format))}</span>
                      </>
                  : translations.projects["projects"]["saved"]["caption_date_lable"] + props.projectDate}

              </p>
            </div>
            {(browserUtil.isTouchDevice() && props.showDeleteIcon) ?
                <>
                <div onClick={editProject} className="editProject icon-icon_edit" tabIndex={0} data-project_id={`${props.id}`} data-project_state={`${props.currentState}`} data-name={`edit_project_${props.id}`}></div>
                {/** @ts-ignore */}
                <div onClick= {deleteProject} className="deleteProject icon-icon_delete_outline" tabIndex={0} project_id={`${props.id}`} project_state={`${props.currentState}`} name={`delete_project_${props.id}`}></div>
                </>: null}
              {(props.state == 'DeletedFree' || props.state == 'DeletedArchived')?
              <div className="delete_project_options_mobile">
                  {/** @ts-ignore */}
                  <a onClick={openRestoreOverlay} className="restoreProject" project_id={`${props.id}`} >{ translations.projects["action_container"]["restore"]}</a>
              </div>
              : ""}
          </div>
        </figure>
       { (props.state == 'Archived' || props.state == 'DeletedArchived') ?
          <div className="purchased_status">
              { translations.projects["action_container"]["purchasedtag"]}
          </div>
        : ""}
         {(props.sourceGroup.indexOf('sf-mobile-ios') != -1 || props.sourceGroup.indexOf('sf-mobile-android') != -1)?
                 <div className="mobile_app_project icon-icon_device_mobile"></div>
         : ""}
      </div>
    </div>
  </li>)
}

export default Project;